<template>
  <DataList
    title="Проекти"
    resource="projects-projects"
    :columns="columns"
    :get-items-fn="getProjects"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as projectsApi from "../../backend/projectsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Дата створення", name: "date" },
      { title: "Назва", name: "title" },
      { title: "Опис", name: "description" },
    ],
  }),
  computed: {
  },
  created() {
  },
  methods: {
    getProjects(...args) {
      return projectsApi.getProjects(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>